import React from "react";
import PropTypes from "prop-types";

import styles from "./MainButtonInput.module.scss";
export class MainButtonInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      focused: false,
    };
  }

  render() {
    const {
      label,
      value,
      handleClick,
      required,
    } = this.props;

    return (
      <div className={styles["main-button-input-container"]} onClick={handleClick}>
        {!value && <div className={styles["main-button-input-label-placeholder"]}>
          {label}{" "}
          {required && <span className={styles["main-button-input-required-label"]}>*</span>}
        </div>}

        {value && 
        <div className={styles["main-button-input-wrapper"]}>
          <div className={styles["main-input-label"]}>
                {label}{" "}
                {required && (
                  <span className={styles["main-input-required-label"]}>*</span>
                )}
              </div>
          <div className={styles["main-button-input-value"]}>{value}</div>

        </div>
          }
          
        <i className={styles["icon"] + " icon-chevron-derecha"} data-automation-id="input-button-click"></i>
      </div>
    );
  }
}

MainButtonInput.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  handleClick: PropTypes.func,
};

export default MainButtonInput;
